module.exports = __webpack_public_path__ + "static/media/modify.fc8950d0.svg";